import React from 'react';
import EvaluationProjectPartner from './EvaluationProjectPartner';
import useQuery from './useQuery';

export default function useMapping(props) {
  const models = useQuery(props);

  const type = 'evaluation-project-partner';

  const entries = models.data.map((value, index) => ({
    type: type,
    value: (
      <EvaluationProjectPartner
        key={`${type}-${index}`}
        evaluation={value}
      />
    ),
    data: value,
    timestamp: value.data.createdAt
  }));

  return {
    models,
    entries
  };
}
